const N = (x) => 0.5 * (1 + erf(x / Math.SQRT2));
function erf(x) {
  const s = Math.sign(x);
  const a = Math.abs(x);
  const t = 1 / (1 + 0.3275911 * a);
  const y = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-a * a);
  return s * y;
}

export function bs(S, K, T, iv, isCall, r = 0.065) {
  if (T <= 0 || iv <= 0) return Math.max(isCall ? S - K : K - S, 0);
  const d1 = (Math.log(S / K) + (r + (iv * iv) / 2) * T) / (iv * Math.sqrt(T));
  const d2 = d1 - iv * Math.sqrt(T);
  return isCall ? S * N(d1) - K * Math.exp(-r * T) * N(d2) : K * Math.exp(-r * T) * N(-d2) - S * N(-d1);
}

export const yearsTo = (expiry) => Math.max((new Date(`${expiry}T15:30:00+05:30`) - Date.now()) / (365 * 86400e3), 0);

// leg: {type: CE|PE|FUT|EQ, strike, side, qty, entry, iv, expiry}
export function legValue(leg, S, atExpiry) {
  if (leg.type === "FUT" || leg.type === "EQ") return S;
  const T = atExpiry ? 0 : yearsTo(leg.expiry);
  return bs(S, leg.strike, T, leg.iv || 0.15, leg.type === "CE");
}

export function payoff(legs, S, atExpiry) {
  return legs.reduce((a, l) => a + (legValue(l, S, atExpiry) - l.entry) * l.qty * (l.side === "BUY" ? 1 : -1), 0);
}

export function analyse(legs, spot) {
  const lo = spot * 0.9;
  const hi = spot * 1.1;
  const pts = [];
  for (let i = 0; i <= 160; i++) {
    const S = lo + ((hi - lo) * i) / 160;
    pts.push({ S: Math.round(S), expiry: payoff(legs, S, true), today: payoff(legs, S, false) });
  }
  const ex = pts.map((p) => p.expiry);
  const unboundedUp = Math.abs(ex[ex.length - 1] - ex[ex.length - 2]) > 1e-6 && ex[ex.length - 1] > ex[ex.length - 2];
  const unboundedDownLoss = Math.abs(ex[ex.length - 1] - ex[ex.length - 2]) > 1e-6 && ex[ex.length - 1] < ex[ex.length - 2];
  const be = [];
  for (let i = 1; i < pts.length; i++) {
    const a = pts[i - 1].expiry;
    const b = pts[i].expiry;
    if ((a < 0 && b >= 0) || (a > 0 && b <= 0)) be.push(Math.round(pts[i - 1].S + ((pts[i].S - pts[i - 1].S) * Math.abs(a)) / (Math.abs(a) + Math.abs(b))));
  }
  const iv = legs.find((l) => l.iv)?.iv || 0.15;
  const T = legs[0]?.expiry ? Math.max(yearsTo(legs[0].expiry), 1 / 365) : 1 / 12;
  const sd = iv * Math.sqrt(T);
  let pop = 0;
  for (let i = 1; i < pts.length; i++) {
    if (pts[i].expiry > 0) {
      const z1 = Math.log(pts[i - 1].S / spot) / sd;
      const z2 = Math.log(pts[i].S / spot) / sd;
      pop += N(z2) - N(z1);
    }
  }
  return {
    pts, breakevens: be, pop: Math.min(Math.max(pop, 0), 1),
    maxProfit: unboundedUp ? Infinity : Math.max(...ex), maxLoss: unboundedDownLoss ? -Infinity : Math.min(...ex),
  };
}

export function maxPain(rows, ticks) {
  let best = null;
  rows.forEach(({ strike: k }) => {
    let pain = 0;
    rows.forEach((r) => {
      const ceOi = ticks[r.CE]?.oi || 0;
      const peOi = ticks[r.PE]?.oi || 0;
      pain += Math.max(k - r.strike, 0) * ceOi + Math.max(r.strike - k, 0) * peOi;
    });
    if (best == null || pain < best.pain) best = { strike: k, pain };
  });
  return best?.strike;
}
